const QUALITY = /\b(4k|uhd|fhd|full\s*hd|1080p?|720p?|480p?|hd|sd|web[- .]?dl|webrip|bluray|blu[- .]?ray|hdr|dv|dolby|dublado|dub|legendado|leg|dual|multi|h\.?26[45])\b/gi
const EPISODE_PATTERNS = [
  /\bS(\d{1,2})\s*E(\d{1,5})\b/i,
  /\b(\d{1,2})x(\d{1,5})\b/i,
  /\bT(?:EMPORADA)?\s*(\d{1,2})\s*(?:EP?|EPIS[ÓO]DIO)\s*(\d{1,5})\b/i,
  /\bSEASON\s*(\d{1,2})\s*EPISODE\s*(\d{1,5})\b/i,
]
const SEASON_SUFFIX = /(?:[-–—|:]\s*)?(?:S|T(?:EMPORADA)?|SEASON)\s*\d{1,2}\s*$/i

export function normalize(value: string): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' e ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
}

export function extractYear(value: string): number | undefined {
  const matches = [...String(value).matchAll(/\b(19\d{2}|20\d{2})\b/g)]
  if (!matches.length) return undefined
  return Number(matches[matches.length - 1][1])
}

export function extractEpisode(value: string): { season: number; episode: number } | null {
  for (const pattern of EPISODE_PATTERNS) {
    const match = value.match(pattern)
    if (match) return { season: Number(match[1]), episode: Number(match[2]) }
  }
  return null
}

export function cleanDisplayTitle(value: string): string {
  return String(value || '')
    .replace(/\[[^\]]*]/g, ' ')
    .replace(/\([^)]*(?:19\d{2}|20\d{2}|4k|hd|fhd|dub|leg)[^)]*\)/gi, ' ')
    .replace(QUALITY, ' ')
    .replace(/[._]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function extractSeriesTitle(value: string): string {
  let title = cleanDisplayTitle(value)
  for (const pattern of EPISODE_PATTERNS) title = title.replace(pattern, ' ')
  return title.replace(SEASON_SUFFIX, ' ').replace(/[-–—|:]\s*$/, '').replace(/\s+/g, ' ').trim()
}

export function parseAliases(raw: string): Record<string, string[]> {
  const aliases: Record<string, string[]> = {}
  for (const line of raw.split(/\r?\n/)) {
    const trimmed = line.trim()
    if (!trimmed || trimmed.startsWith('#') || !trimmed.includes('=')) continue
    const [left, right] = trimmed.split('=', 2)
    const key = normalize(left)
    const values = right.split(',').map(normalize).filter(Boolean)
    if (key && values.length) aliases[key] = values
  }
  return aliases
}
